import { render, staticRenderFns } from "./BSignUpLayout.vue?vue&type=template&id=673746ac&"
import script from "./BSignUpLayout.vue?vue&type=script&lang=ts&"
export * from "./BSignUpLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports